// Central registry of numeric masterType ids used when navigating to /auditScreen/:companyId/:masterType(/:branchId).
// Each screen that links to the audit log should import this instead of hardcoding its masterType number.
const MASTER_TYPE_CONFIG = {
    PLANT_DEPOT: 1,
    LOCATION_NETWORK: 2,
    COMPANY_INFO: 3,
    DRIVER_MASTER: 4,
    TRUCK_MASTER: 5,
    DEPARTMENT_ROLES: 6,
    PLANT_INDENTS: 7,
    VENDOR_MAPPING: 8,
    VOLUMETRIC_WEIGHT: 9,
    INVENTORY_MASTER: 10,
    SUB_PLANTS: 11,
    LOADING_VENDOR: 12,
    LOADING_BAY: 13,
    MFS_MASTER: 14,
    WEIGH_BRIDGE_MASTER: 15,
    WEIGH_BRIDGE_CONVERSION: 16,
    WAREHOUSE_WISE_STORAGE: 17,
    MATERIAL_CONVERSION: 19,
    ROUTE_CODE: 20,
    MATERIAL_MRP: 22,
    PLANT_USERS: 25,
    APPROVER_MATRIX: 26,
    RAW_MATERIAL_MASTER: 28,
    DIGITAL_LR: 30,
    PHARMA_TANKER_MASTER: 31,
    INDENT_REASON: 32,
    INDENT_CONFIG: 33,
    RFQ_SETTINGS: 34,
    COMPANY_CATEGORY_VENDOR: 35,
    WAREHOUSE_PARTICULAR: 36,
    WAREHOUSE_PARTICULAR_TEMPLATE: 37,
    ROUTE_MASTER: 38,
    DISPOSAL_MATERIAL_MASTER: 39,
    DISPOSAL_MATERIAL_CONTRACT_MANAGEMENT: 40,
    WEIGH_BRIDGE_CONFIG: 42,
    PFIZER_ITEM_MASTER: 43,
    PARKING_LOT_MASTER: 45,
    CONFIGURATION_DEBIT_NOTE: 48,
    PROVIDERS_MAPPING: 49,
    SAP_MASTER: 58,
    ACTION_MASTER: 59,
    MANNED_WEIGHBRIDGE_MASTER: 61,
    RF_DEVICE_MASTER: 62,
    TOLERANCE_MASTER: 64,
    TRANSPORTER_BYPASS_MASTER: 65,
    MEANS_OF_TRANSPORT_MASTER: 67,
    PRODUCT_CATEGORY: 68,
    PACKAGING_TYPE: 69,
    PRICING_BASIS: 70,
    CONTRACT_VEHICLE_TYPE: 71,
    VEHICLE_BODY: 72,
    UOM: 73,
    LOADABILITY: 74,
    VEHICLE_DETAILS: 75,
    CURRENCY: 76,
    AUTO_DECREMENT: 77,
    DEBIT_MASTER: 78,
    ACCOUNT_EVENTS: 79,
    APPROVER_TYPE_MASTER: 80,
    CONFIGURATION_REASONS: 81,
    CREDIT_MASTER: 82,
    ACCOUNT_MASTER: 83,
    CONFIGURATION_MOVES: 84,
    CONFIGURATION_ACTIONS: 85,
    CONFIGURATION_CHECKLISTS: 86,
    DIESEL_PRICE_HIKE: 88,
    LIABILITY_STRUCTURE: 89,
    VOLUMETRIC_WEIGHT_STRUCTURE: 90,
    LANE_MASTER: 91,
    VEHICLE_PLANNING_TRUCK_MASTER: 92,
    VEHICLE_PLANNING_SKU_MASTER: 93,
    VEHICLE_PLANNING_DRIVER_MASTER: 94,
    CITY_TAT_MASTER: 95,
    ODA_MASTER: 96,
    NETWORK_MASTER: 97,
    HUB_MASTER: 98,
    DISCOUNT_STRUCTURE_MASTER: 99,
    CONTRACT_TENURE_CONFIG: 100,
    VENDOR_LANE_MAPPING_MASTER: 101,
    DELAY_PENALTY_STRUCTURE: 102,
    MODULE_CONFIG: 103,
    OPERATION_TIME: 104,
    DEMURRAGE: 106,
    CONFIGURATION_FIELDS: 107,
    FOCUS_MASTER: 108,
};

export default MASTER_TYPE_CONFIG;
